export const PAGE_NOT_FOUND_NAME = 'PageNotFound'

export const REDIRECT_NAME = 'Redirect'

export const ROOT_NAME = 'Root'

export const LAYOUT = () => import('@views/Layout/page/AkeLayouts.vue')

// export const REDIRECT_LAYOUT = () => import('@views/Layout/page/RedirectLayout.vue')
